import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Topic from '../Topic';

const CatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px 0;
  margin: 0 15px;
  border-bottom: 1px solid ${props => props.theme.color.medGrey};
`;

const IRight = styled.div`
  ${props =>
    props.onDisplay
      ? `border: solid ${props.theme.color.primary};`
      : `border: solid ${props.theme.color.black};
  `};
  border-width: 0 3px 3px 0;
  display: inline-block;
  float: right;
  padding: 3px;
  margin-right: 15px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
`;

const IDown = styled(IRight)`
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
`;

const H1 = styled.h1`
  font-family: 'Lato', sans-serif;
  font-size: 1.5em;
  font-style: normal;
  font-weight: 700;
  ${props =>
    props.onDisplay
      ? `color: ${props.theme.color.primary};
      `
      : `color: ${props.theme.color.black};
      `};
`;

const Topics = styled.div`
  flex-direction: row;
  flex-wrap: wrap;
  float: left;
`;

class MobileCategory extends Component {
  static propTypes = {
    index: PropTypes.number,
    isMobile: PropTypes.bool,
    model: PropTypes.string,
    name: PropTypes.string,
    onDisplay: PropTypes.bool,
    selectCatagory: PropTypes.func,
    topics: PropTypes.array
  };

  render() {
    const {
      index,
      isMobile,
      model,
      name,
      onDisplay,
      selectCatagory,
      topics
    } = this.props;
    return (
      <CatWrapper>
        <H1 onDisplay={onDisplay} onClick={e => selectCatagory(e, index, true)}>
          {name}
          {onDisplay ? (
            <IDown onDisplay={onDisplay} />
          ) : (
            <IRight onDisplay={onDisplay} />
          )}
        </H1>
        {onDisplay &&
          topics && (
          <Topics>
            {topics.map((topic, i) => {
              return (
                <Topic
                  isMobile={isMobile}
                  image={topic.topicImage}
                  key={i}
                  model={model}
                  topic={topic}
                />
              );
            })}
          </Topics>
        )}
      </CatWrapper>
    );
  }
}

export default MobileCategory;



// WEBPACK FOOTER //
// ./src/components/Category/MobileCategory.js